module.exports = __webpack_public_path__ + "img/mobilePhoneOrange.e51ed791.png";